import CryptoJS from 'crypto-js';
import { apiUrl2 } from "../configs/constant";
import { generateRandomKey } from "./format-data";
const password = process.env.REACT_APP_PASSWORD;

export const registerReferalCode = async (address) => {
  const url = `${apiUrl2}/refer/register?address=${address}`;

  let response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const referalCodeCheck = async (code) => {
  const url = `${apiUrl2}/refer/check?code=${code}`;

  let response = await fetch(url, {
    method: 'GET',
  })

  return await response.json();
}
export const registerReferalHistory = async (data) => {
  const url = `${apiUrl2}/refer/history`;
  data.randomKey = generateRandomKey(16);
  data.randomKeyHash = CryptoJS.AES.encrypt(data.code +data.randomKey, password).toString();

  let response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })

  return await response.json();
}

export const getReferalHistory = async (address) => {
  const url = `${apiUrl2}/refer/history?address=${address}`;

  let response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getReferalHistoryIndex = async (address, page, limit) => {
  const url = `${apiUrl2}/refer/history/index?address=${address}&page=${page}&limit=${limit}`;

  let response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getReferalParentAddress = async (address) => {
  const url = `${apiUrl2}/refer/getParent?address=${address}`;

  let response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

